// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GrantAdminRequest
 */
export interface GrantAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof GrantAdminRequest
     */
    email: string;
}

/**
 * Check if a given object implements the GrantAdminRequest interface.
 */
export function instanceOfGrantAdminRequest(value: object): value is GrantAdminRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function GrantAdminRequestFromJSON(json: any): GrantAdminRequest {
    return GrantAdminRequestFromJSONTyped(json, false);
}

export function GrantAdminRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrantAdminRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function GrantAdminRequestToJSON(json: any): GrantAdminRequest {
    return GrantAdminRequestToJSONTyped(json, false);
}

export function GrantAdminRequestToJSONTyped(value?: GrantAdminRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

